import { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import ButtonUtil from "../UI/ButtonUtil";
import * as httpService from "util/HttpService";
import { callApi } from "util/HttpService";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { alert, modalConfirm } from "components/web/cmmn/CmmnConfirm";
import * as Yup from 'yup';


//img
import Activity from 'asset/mobile_web/img/icon/filled/dashboard_b.svg';
import TextFields from "components/web/UI/TextFields";

const ModalWrap = styled.div`
    background-color: #fff;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    transform: translateY(100%);
    transition: transform 0.4s, visibility 0.4s;
    ${(props) =>
        props.$isVisible &&
        css`
            visibility: visible;
            transform: translateY(0);
        `
    }
    width: 100%;
    position: fixed;
    z-index: 1000;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    height: ${(props) => props.$viewportHeight}px;
    .dp-flex {
        display: flex;
    }
    .align-cen {
        align-items: center;
    }
    .space-between {
        justify-content: space-between;
    }
    .nav-tabs {
        border: none;
        display: flex;
        padding: 15px;
        flex-wrap: nowrap;
        .nav-item {
            margin-right: 5px;
            &:last-child {
                margin: 0;
            }
            .nav-link {
                border: none;
                font-size: 14px;
                background-color: ${({ theme }) => theme.colors.gray5};
                border: 1px solid ${({ theme }) => theme.colors.gray5};
                color: ${({ theme }) => theme.colors.gray6};
                border-radius: 100px;
                &.active {
                    border: 1px solid ${({ theme }) => theme.colors.red};
                    border-radius: 100px;
                    color: ${({ theme }) => theme.colors.red};
                    font-size: 14px;
                    background-color: var(--bs-nav-tabs-link-active-bg) !important;
                }
            }
        }
    }
    .tab-content {
        margin-top: 20px;
        .tab-pane {
            padding: 0px 20px 20px 20px;
        }
    }
`;
const ModalHeader = styled.div`
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray7};
    .img-box {
        display: flex;
        img {
            margin-right: 10px;
        }
    }
    h2 {
        position: relative;
        top: 0.9px;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.dark2};
        font-weight: 500;
    }
    button {
        background-color: #fff;
        svg {
            font-size: 16px;
            color: ${({ theme }) => theme.colors.dark2};
        }
    }
`;
const ModalContent = styled.div`
    width: 100%;
    height: calc(${(props) => props.$viewportHeight}px - 200px);
    overflow-y: auto;
    h3 {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.dark2};
        font-weight: bold;
        width: 35%;
    }
    h4 {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.dark2};
        font-weight: 400;
        width: 70%;
    }
    h5 {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.dark2};
        margin-left: 5px;
    }
    .input_box:last-of-type {
        margin: 0 !important;
    }
`;
const ErrorMsg = styled.p`
    margin-left: 0rem;
    font-size: 0.9rem;
    color: #ef2929;
`;
//section이라서 상위 section인 MainLayoutComponents의 영향을 받음. !important임시 추가
const RefundSection = styled.section` 

  body {
    line-height: 1;
    font-size: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: "Noto Sans KR", sans-serif;
    font-size: 10px;
  }

  padding: 20px 20px 20px 20px !important;
  //padding: 20px 20px 20px 20px;
  
`;
const RefundDetailWrap = styled.ul`
  li{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
    border-bottom: 1px solid #EEEEEE;
  }
  
  li:last-of-type{
    border-bottom: none;
    margin-bottom: 10px;
  }
  
  li h3{
    font-size: 15px;
    color: #3b3b3b;
    font-weight: 500;
    min-width: 80px;
  }
  div {
    min-width: 250px;
  }
  p{
    font-size: 12px;
  }

`;
const TextArea = styled.textarea`
    width: 100%;
    height: 11rem;
    resize: none;
    border-radius: 0rem;
    font-size:14px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    outline: none;
    padding: 0 0.8rem;
    padding-top: 0.8rem;
    color: #000;
    &:hover {
      border-color: ${({ theme }) => theme.colors.black};
    }
    &:disabled {
        background: #f9f9f9;
        color: ${({ theme }) => theme.colors.gray3};
        &:hover {
        }
    }
`;
const BtnWrap = styled.div`
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btn {
        width: 35%;
    }
`;

export default function StlmRefundModal({
    show,
    onHide,
    data,
    brchClsfCd,
    t,
}) {

    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    const [isVisible, setIsVisible] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        const updateViewportHeight = () => {
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', updateViewportHeight);
        updateViewportHeight();
         return () => {
            window.removeEventListener('resize', updateViewportHeight);
        };
    }, []);

        
    useEffect(() => {
        const handleResize = () => {
            if (show) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'unset';
        }};
        if (show) {
            setIsVisible(true);
            if (modalRef.current) {
                modalRef.current.scrollTop = 0;
            }
            document.body.style.overflow = "hidden";
            
            window.addEventListener('resize', handleResize);
            
        } else {
            setIsVisible(false);
            document.body.style.overflow = 'unset';
            
        }
        return () => {
            window.removeEventListener('resize', handleResize);
            document.body.style.overflow = 'unset';
        };
    }, [show]);


    const defaultRefundReqData = {
        rfdmAmt:'',
        reason:'',
    };
    const [refundReqData, setRefundReqData] = useState(defaultRefundReqData);

    const refundDataChange = (event) => {
        const {name,value} = event.target;
        
        setRefundReqData(prev => ({
           ...prev,
            [name]: value
        }));
    };

    // 페이지 로드 시 초기값 세팅
    useEffect(() => {
        if (data?.stlmAmt != null && data?.qrStlmLnkgHstSqno != null) {
            setRefundReqData(prev => ({
                ...prev,
                qrStlmLnkgHstSqno: data.qrStlmLnkgHstSqno,
                crgeId: data.crgeId,
                eqmtNo: data.eqmtNo,
                ordId: data.ordId,
                rfdmAmt: Number(data.stlmAmt),
                cutmId: data.cutmId,
            }));
        }
    }, [data]);

    /* 환불 req데이터 조회 : 삭제예정
    useEffect(() => {
        console.log(refundReqData);
    },[refundReqData]);
    */

    const [errors, setErrors] = useState({});

    const validationSchema = Yup.object().shape({
        rfdmAmt: Yup.string().required(t("alert.refundAmtCheck")),
        reason: Yup.string().required(t("alert.refundReasonCheck")),
    });

    const handleCmmnBtnClick = async (btnNm) => {
        switch (btnNm) {
            case "cmmnRefundBtn":
                validationSchema.validate(refundReqData, {abortEarly: false})
                .then(() => {
                    try {
                        modalConfirm("", t("alert.refundCheck"), () => {
                            httpService.callApi("POST",refundReqData,`/web/api/payments/refund`)
                            .then((res) => {
                                //console.log(res);
                                alert("", "환불 완료", () => { onHide() });
                            })
                            .catch((error) => {
                                console.error(error);
                                alert("", "환불 실패", () => { return });
                            });
                        });
                    } catch (error) {
                        console.error('Error fetching Data',error);
                    }
                })
                .catch((err) => {
                    const newErrors = {};
                    err.inner.forEach((error) => {
                        newErrors[error.path] = error.message;
                    });
                    setErrors(newErrors);
                });

            break;
            default:break;
        }
    };

    return (
        <>
        <ModalWrap $isVisible={isVisible} id="cnfModal" $viewportHeight={viewportHeight}>
            <ModalHeader>
                <div className="img-box">
                    <img src={Activity} alt={Activity} />
                    <h2>{t("qrStlmMgtPage.refund")}</h2>
                </div>
                <ButtonUtil className="close-btn bottom-modal-close-btn"
                    onClick={onHide}>
                    <FontAwesomeIcon icon={faXmark} className="close-i" color="black" height="25" />
                </ButtonUtil>
            </ModalHeader>
            <ModalContent $viewportHeight={viewportHeight} ref={modalRef}>
                <RefundSection>
                    <RefundDetailWrap>
                        <li>
                            <h3>{t("qrStlmMgtPage.chargeId")}:</h3>
                            <p>{data?data.crgeId:"데이터없음"}</p>
                        </li>
                        <li>
                            <h3>{t("qrStlmMgtPage.orderNo")}:</h3>
                            <p>{data?data.ordId:"데이터없음"}</p>
                        </li>
                        <li>
                            <h3>{t("qrStlmMgtPage.payMethod")}:</h3>
                            <p>{data?data.stlmMethCd:"데이터없음"}</p>
                        </li>
                        <li>
                            <h3>{t("qrStlmMgtPage.payAmt")}:</h3>
                            <p>{data?data.stlmAmt:"데이터없음"}</p>
                        </li>
                        <li>
                            <h3>{t("qrStlmMgtPage.refundAmt")}: ¥</h3>
                            <div>
                                <TextFields 
                                    type="number"
                                    name="rfdmAmt"
                                    step={1}
                                    min={0}
                                    max={data?Number(data.stlmAmt):9999}
                                    value={refundReqData.rfdmAmt}
                                    onChangeValue={refundDataChange}
                                    className="w-100"
                                    inputMode="numeric"
                                    pattern="\d*"
                                />
                                {errors.rfdmAmt&& <ErrorMsg>{errors.rfdmAmt}</ErrorMsg>}
                            </div>
                        </li>
                        <li>
                            <h3>{t("qrStlmMgtPage.refundReason")}: </h3>
                            <div>
                                <TextArea 
                                    placeholder="사유 입력"
                                    name="reason"
                                    maxLength="100"
                                    onChange={(e) => refundDataChange(e)}
                                />
                                {errors.reason&& <ErrorMsg>{errors.reason}</ErrorMsg>}
                            </div>
                        </li>
                    </RefundDetailWrap>
                </RefundSection>
                <BtnWrap>
                    <ButtonUtil className="btn btn-outline-light round-solid-medium-btn"
                        value={t("common.cancelLable")}
                        onClick={() => { onHide() }}
                    />
                    <ButtonUtil className="btn btn-danger round-filled-small-btn"
                        value={t("qrStlmMgtPage.refund")}
                        onClick={() => { handleCmmnBtnClick("cmmnRefundBtn") }}
                    />
                </BtnWrap>

            </ModalContent>

        </ModalWrap>
        </>
    );
}